/**
 * Event catalog constants (conex360)
 *
 * Static option lists for the Event Types UI. Entity types and actions are NOT
 * constants — they come from the API (getEventEntityTypes / getEventActions).
 *
 * TOPICS is provisional until the ConEx Events topics are confirmed (spec §9).
 */

export const TOPICS = ['notifications', 'provisioning', 'workloads', 'system'] as const

/**
 * Fallback ReMa resource instances for the publisher/subscriber pickers, used by the event
 * screens ONLY when getResourceInstances returns nothing (i.e. no backend). This keeps the
 * shared getResourceInstances endpoint un-mocked, so the ReMa screens still hit the real API.
 * URIs line up with the seeded event-type mocks so those rows resolve to friendly names.
 */
export const EVENT_WORKLOAD_INSTANCES = [
  { instanceUri: 'cnx://997/component/svc-core', resourceInstanceName: 'Core Service', resourceCategory: 'component' },
  { instanceUri: 'cnx://997/component/svc-notifications', resourceInstanceName: 'Notifications Service', resourceCategory: 'component' },
  { instanceUri: 'cnx://997/component/svc-provisioning', resourceInstanceName: 'Provisioning Service', resourceCategory: 'component' },
  { instanceUri: 'cnx://997/component/svc-workloads', resourceInstanceName: 'Workloads Service', resourceCategory: 'component' },
]
export const EVENT_STATUSES = ['active', 'inactive'] as const
export const REFERENCE_FIELD_TYPES = ['string', 'number', 'boolean', 'object', 'array'] as const

export type Topic = (typeof TOPICS)[number]
export type EventStatus = (typeof EVENT_STATUSES)[number]
export type ReferenceFieldType = (typeof REFERENCE_FIELD_TYPES)[number]

// Blocked words for reference-field names — events must never carry credentials,
// codes or storage keys (spec §6.1). Word-boundary aware (see hasBlockedWord).
export const BLOCKED_FIELD_WORDS = new Set<string>([
  'password',
  'secret',
  'token',
  'otp',
  's3key',
  'appkey',
  'nwkskey',
  'appskey',
])
